export default [
  {
    path: "/schedules",
    name: "Schedules",
    component: () => import(/* webpackChunkName: "schedules" */ "@/pages/User/Schedules/Index.vue"),
    meta: { auth: true }
  },
  {
    path: "/schedule/preview/:id",
    name: "UserSchedulePreview",
    component: () => import(/* webpackChunkName: "schedule-preview" */ "@/pages/User/Schedules/Preview/IndexView.vue"),
    meta: { auth: true }
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import(/* webpackChunkName: "profile" */ "@/pages/User/Profile/IndexView.vue"),
    meta: { auth: true }
  },
  {
    path: "/profile/edit",
    name: "ProfileEdit",
    component: () => import(/* webpackChunkName: "profile-edit" */ "@/pages/User/Profile/EditView.vue"),
    meta: { auth: true }
  },
  {
    path: "/feedbacks",
    name: "UserFeedbacks",
    component: () => import(/* webpackChunkName: "user-feedbacks" */ "@/pages/User/Feedbacks/IndexView.vue"),
    meta: { auth: true }
  },
  {
    path: "/statistics/me",
    name: "UserStats",
    component: () => import(/* webpackChunkName: "user-stats" */ "@/pages/Statistics/UserStats/IndexView.vue"),
    meta: { auth: true }
  },
  {
    path: "/unavailability",
    name: "Unavailability",
    component: () => import(/* webpackChunkName: "unavailability" */ "@/pages/Unavailability/IndexView.vue"),
    meta: { auth: true, feature: "compliance" }
  },
  {
    path: "/burnout",
    name: "Burnout",
    component: () => import(/* webpackChunkName: "burnout" */ "@/pages/Burnout/IndexView.vue"),
    meta: { auth: true, authorize: "manager", feature: "burnout" }
  }
]
